import { BackendBet } from '../types';

export const isBackendBetEntryFromClient = (entry: unknown):entry is BackendBet => {
  return entry instanceof Object && 'price0' in entry;
};
